type FileSize = '10MB';
const FILE_SIZES: Record<FileSize, [number, string]> = {
    '10MB': [10 * 1024 * 1024, '10MB'],
};
export const maxFileSize = (limit: FileSize) => (file?: File) => {
    if (!file) return true;
    const [maxSize, sizeLabel] = FILE_SIZES[limit];
    if (file.size > maxSize) {
        return `File size exceeds ${sizeLabel}`;
    }
    return true;
};
